/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DomainName
 */
export interface DomainName {
    /**
     * 
     * @type {number}
     * @memberof DomainName
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof DomainName
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof DomainName
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DomainName
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof DomainName
     */
    readonly leaksCount: string;
}

/**
 * Check if a given object implements the DomainName interface.
 */
export function instanceOfDomainName(value: object): value is DomainName {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('leaksCount' in value) || value['leaksCount'] === undefined) return false;
    return true;
}

export function DomainNameFromJSON(json: any): DomainName {
    return DomainNameFromJSONTyped(json, false);
}

export function DomainNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainName {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'leaksCount': json['leaks_count'],
    };
}

  export function DomainNameToJSON(json: any): DomainName {
      return DomainNameToJSONTyped(json, false);
  }

  export function DomainNameToJSONTyped(value?: Omit<DomainName, 'id'|'created_at'|'updated_at'|'leaks_count'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

